/**
 * Creates a method that tests to see if a plan (IPlanContentMatcher), matches a list of predefined plan names (Case Insensitive)
 *
 * @param planNames
 */
import { IPlanContentMatcher } from '../../../Energy';
import { DETAILS_CONTENT_KEYS, PlanDetailsContentKey } from '../../typings';
import {
  IconBattery,
  IconBilling,
  IconCalendar,
  IconDescription,
  IconElectricVehicle,
  IconEnergySavingsLeaf,
  IconLockOpen,
  IconPlus,
  SvgIconProps,
} from '@origin-digital/ods-icons';
import React, { ReactElement } from 'react';

export const createPlanNameMatcher =
  (planNames: string[]) => (planOrTitle: IPlanContentMatcher | string) => {
    const title = (planOrTitle as IPlanContentMatcher).title || planOrTitle || '';
    return planNames.map((n) => n.toLowerCase()).indexOf(title.toLowerCase()) !== -1;
  };

/**
 * Returns the icon mapping configuration for the content
 * @param contentKey
 */
export function getKeyDetailsContentIcon(
  contentKey: PlanDetailsContentKey
): ReactElement<SvgIconProps> {
  return planKeyDetailsContentIconMappings[contentKey];
}

const planKeyDetailsContentIconMappings: {
  [contentKey: string]: ReactElement<SvgIconProps>;
} = {
  [DETAILS_CONTENT_KEYS.Rates]: <IconBilling color="neutral" />,
  [DETAILS_CONTENT_KEYS.BenefitPeriod]: <IconCalendar color="neutral" />,
  [DETAILS_CONTENT_KEYS.ExitFees]: <IconLockOpen color="neutral" variant="line" />,
  [DETAILS_CONTENT_KEYS.CarbonNeutral]: <IconEnergySavingsLeaf color="neutral" variant="line" />,
  [DETAILS_CONTENT_KEYS.Extras]: <IconPlus color="neutral" />,
  [DETAILS_CONTENT_KEYS.EVAddOn]: <IconElectricVehicle color="neutral" />,
  [DETAILS_CONTENT_KEYS.BYOBattery]: <IconBattery color="neutral" />,
  [DETAILS_CONTENT_KEYS.Addons]: <IconEnergySavingsLeaf color="neutral" variant="line" />,
  [DETAILS_CONTENT_KEYS.GreenOptions]: <IconEnergySavingsLeaf color="neutral" variant="line" />,
  [DETAILS_CONTENT_KEYS.EligibilityCriteiria]: <IconDescription color="neutral" variant="line" />,
};
